import { Vacancy } from '@models';
import { Firestore, orderBy, where } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class VacancyService extends BaseService<Vacancy> {
  protected readonly documentPath = '/vacancies';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }

  getTeamVacancies(teamId: string) {
    return this.getWithQuery([
      orderBy('endDate', 'asc'),
      where('teamId', '==', teamId),
      where('active', '==', true),
      where('endDate', '>', new Date()),
    ]);
  }
}
